import script from "./DashboardContentTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardContentTab.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardContentTab.vue?vue&type=style&index=0&id=34ae4568&lang=css"

const __exports__ = script;

export default __exports__